import {
    BaloiseWtcReason,
    CityMultiLingualDTO,
    GuaranteeDto,
    Street,
} from "@lg-cfa/services";
import { Broker, ThankYouData } from "@lg-cfa/types";
import { atom, selector } from "recoil";

import { GetTariffParameterObjectCarType, VehicleType } from "@enums";
import { persistAtom } from "@states/persist";
import { Insurance, UserDataInterface } from "@types";

export const weTakeCareActivated = atom<boolean>({
    key: "weTakeCareActivated",
    default: false,
    effects_UNSTABLE: [persistAtom],
});

export const weTakeCareStepout = atom<boolean>({
    key: "weTakeCareStepout",
    default: false,
    effects_UNSTABLE: [persistAtom],
});

export const carTypeState = atom<GetTariffParameterObjectCarType | undefined>({
    key: "carTypeState",
    default: undefined,
    effects_UNSTABLE: [persistAtom],
});

export const carDescriptionMakeState = atom<string>({
    key: "carDescriptionMakeState",
    default: "",
    effects_UNSTABLE: [persistAtom],
});

export const carDescriptionModelState = atom<string>({
    key: "carDescriptionModelState",
    default: "",
    effects_UNSTABLE: [persistAtom],
});

export const carDescriptionVehicleTypeState = atom<VehicleType | undefined>({
    key: "carDescriptionVehicleTypeState",
    default: undefined,
    effects_UNSTABLE: [persistAtom],
});

export const carDescriptionFuelState = atom<string>({
    key: "carDescriptionFuelState",
    default: "",
    effects_UNSTABLE: [persistAtom],
});

export const carDescriptionPowerState = atom<string>({
    key: "carDescriptionPowerState",
    default: "",
    effects_UNSTABLE: [persistAtom],
});

export const carDescriptionCatalogValueState = atom<string>({
    key: "carDescriptionCatalogValueState",
    default: "",
    effects_UNSTABLE: [persistAtom],
});

export const carDescriptionDateRegistrationState = atom<string>({
    key: "carDescriptionDateRegistrationState",
    default: "",
    effects_UNSTABLE: [persistAtom],
});

export const carDescriptionDatePurchasedState = atom<string>({
    key: "carDescriptionDatePurchasedState",
    default: "",
    effects_UNSTABLE: [persistAtom],
});

export const carDescriptionInvoiceValueState = atom<string>({
    key: "carDescriptionInvoiceValueState",
    default: "",
    effects_UNSTABLE: [persistAtom],
});

export const carDetailsSecurityOptionsState = atom<string[]>({
    key: "carDetailsSecurityOptionsState",
    default: [],
    effects_UNSTABLE: [persistAtom],
});

export const carDetailsMileageState = atom<string>({
    key: "carDetailsMileageState",
    default: "0",
    effects_UNSTABLE: [persistAtom],
});

export const driverInformationBirthdayState = atom<string>({
    key: "driverInformationBirthdayState",
    default: "",
    effects_UNSTABLE: [persistAtom],
});

export const driverInformationCityState = atom<CityMultiLingualDTO | undefined>(
    {
        key: "driverInformationCityState",
        default: undefined,
        effects_UNSTABLE: [persistAtom],
    },
);

export const driverInformationPostalCodeState = atom<string>({
    key: "driverInformationPostalCodeState",
    default: "",
    effects_UNSTABLE: [persistAtom],
});

export const driverInformationLetterboxState = atom<string>({
    key: "driverInformationLetterboxState",
    default: "",
    effects_UNSTABLE: [persistAtom],
});

export const driverInformationNumberState = atom<string>({
    key: "driverInformationNumberState",
    default: "",
    effects_UNSTABLE: [persistAtom],
});

export const driverInformationStreetState = atom<Street | undefined>({
    key: "driverInformationStreetState",
    default: undefined,
    effects_UNSTABLE: [persistAtom],
});

export const driverHistory_LicenseState = atom<string>({
    key: "driverHistory_LicenseState",
    default: "",
    effects_UNSTABLE: [persistAtom],
});

export const driverHistory_InsuranceState = atom<string>({
    key: "driverHistory_InsuranceState",
    default: "",
    effects_UNSTABLE: [persistAtom],
});

export const driverHistory_AccidentsState = atom<string>({
    key: "driverHistory_AccidentsState",
    default: "",
    effects_UNSTABLE: [persistAtom],
});
export const totalPriceState = atom<number>({
    key: "totalPriceState",
    default: 0,
    effects_UNSTABLE: [persistAtom],
});

export const insuranceChoiceState = atom<Insurance | undefined>({
    key: "insuranceChoiceState",
    default: undefined,
    effects_UNSTABLE: [persistAtom],
});

export const additionalCoverState = atom<GuaranteeDto[]>({
    key: "additionalCoverState",
    default: [],
    effects_UNSTABLE: [persistAtom],
});

export const brokerDataState = atom<Broker | undefined>({
    key: "brokerDataState",
    default: undefined,
    effects_UNSTABLE: [persistAtom],
});

export const yourInformationFirstNameState = atom<string>({
    key: "yourInformationFirstNameState",
    default: "",
    effects_UNSTABLE: [persistAtom],
});

export const yourInformationLastNameState = atom<string>({
    key: "yourInformationLastNameState",
    default: "",
    effects_UNSTABLE: [persistAtom],
});

export const yourInformationEmailState = atom<string>({
    key: "yourInformationEmailState",
    default: "",
    effects_UNSTABLE: [persistAtom],
});

export const yourInformationPhoneState = atom<string>({
    key: "yourInformationPhoneState",
    default: "",
    effects_UNSTABLE: [persistAtom],
});

export const yourInformationQuestionState = atom<string>({
    key: "yourInformationQuestionState",
    default: "",
    effects_UNSTABLE: [persistAtom],
});

export const yourInformationConsentState = atom<boolean>({
    key: "yourInformationConsentState",
    default: false,
    effects_UNSTABLE: [persistAtom],
});

export const flowFinishedState = atom<boolean>({
    key: "flowFinishedState",
    default: false,
    effects_UNSTABLE: [persistAtom],
});

export const weTakeCareReason = atom<BaloiseWtcReason | undefined>({
    key: "weTakeCareReason",
    default: undefined,
    effects_UNSTABLE: [persistAtom],
});

export const thankYouDataState = atom<ThankYouData | undefined>({
    key: "thankYouDataState",
    default: undefined,
    effects_UNSTABLE: [persistAtom],
});

export const userDataState = selector({
    key: "userData",
    get: ({ get }): UserDataInterface => {
        return {
            carType: get(carTypeState),
            driverInformationBirthday: get(driverInformationBirthdayState),
            driverInformationCity: get(driverInformationCityState),
            driverInformationLetterBox: get(driverInformationLetterboxState),
            driverInformationPostalCode: get(driverInformationPostalCodeState),
            driverInformationNumber: get(driverInformationNumberState),
            driverInformationStreet: get(driverInformationStreetState),
            carDescriptionMake: get(carDescriptionMakeState),
            carDescriptionModel: get(carDescriptionModelState),
            carDescriptionFuel: get(carDescriptionFuelState),
            carDescriptionPower: get(carDescriptionPowerState),
            carDescriptionCatalogValue: get(carDescriptionCatalogValueState),
            carDescriptionDateRegistration: get(
                carDescriptionDateRegistrationState,
            ),
            carDescriptionDatePurchased: get(carDescriptionDatePurchasedState),
            carDescriptionInvoiceValue: get(carDescriptionInvoiceValueState),
            carDescriptionVehicleType: get(carDescriptionVehicleTypeState),
            carDetailsMileage: get(carDetailsMileageState),
            carDetailsSecurityOptions: get(carDetailsSecurityOptionsState),
            driverHistory_License: get(driverHistory_LicenseState),
            driverHistory_Insurance: get(driverHistory_InsuranceState),
            driverHistory_Accidents: get(driverHistory_AccidentsState),
            totalPrice: get(totalPriceState),
            insuranceChoice: get(insuranceChoiceState),
            brokerData: get(brokerDataState),
            yourInformationFirstName: get(yourInformationFirstNameState),
            yourInformationLastName: get(yourInformationLastNameState),
            yourInformationEmail: get(yourInformationEmailState),
            yourInformationPhone: get(yourInformationPhoneState),
            yourInformationQuestion: get(yourInformationQuestionState),
            yourInformationConsent: get(yourInformationConsentState),
            weTakeCareActivated: get(weTakeCareActivated),
            weTakeCareStepout: get(weTakeCareStepout),
            flowFinished: get(flowFinishedState),
            weTakeCareReason: get(weTakeCareReason),
            thankYouData: get(thankYouDataState),
        };
    },
});
